import { Grid } from '@mui/material';
import React, { FC } from 'react';
import { PublicFooter as Footer } from './AdminPublicFooter';
import { AdminPublicHeader as Header } from './AdminPublicHeader';

export const AdminPublicPageLayout: FC = ({ children }) => {
  return (
    <Grid container direction="column" minHeight="100%">
      <Header />

      <Grid item container direction="column" flex="1 0 auto">
        {children}
      </Grid>

      <Footer />
    </Grid>
  );
};
